import * as React from 'react';
const SvgJournal = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m42.645 7.806 9.678-3.87 36.774 44.516S31.032 59.6 17.484 122c-7.742-52.258 42.58-75.484 42.58-75.484L25.227 2C7.806 9.742 2 17.484 2 17.484"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M112.323 71.677 122 85.226S69.742 73.613 38.774 96.839c23.226-36 81.291-36.774 81.291-36.774l-38.71-48.387-7.742 1.935M29.097 120.065s25.161-31.82 81.29-17.42l-5.806-9.677"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgJournal;
